export const MY_EVENTS_ROUTE = '/my-events';

export const CREATE_EVENT_FORM_ROUTE = `${MY_EVENTS_ROUTE}/create-event`;

export const REFERRAL_LINK_ROUTE = '/referral-link';

export const SALES_CHANNEL_ROUTE = '/sales-channel';

export const REFERRAL_TEAM_ROUTE = '/referral-team';

export const EDIT_EVENT_FORM_ROUTE = `${MY_EVENTS_ROUTE}/edit-event/:eventId`;
export const EDIT_EVENT_PUBLISH_ROUTE = `${MY_EVENTS_ROUTE}/edit-event/:eventId?step=PUBLISH`;
export const ATTENDEES_EVENT_ROUTE = `${MY_EVENTS_ROUTE}/attendees/:eventId`;
export const ZREADING_EVENT_ROUTE = `${MY_EVENTS_ROUTE}/zreading/:eventId`;
export const EVENT_SCANNING_ROUTE = `${MY_EVENTS_ROUTE}/scanning/:eventId`;
export const EVENT_OFFER_ROUTE = `${MY_EVENTS_ROUTE}/offer/:eventId`;
export const EVENT_OFFER_CONTAINER_ROUTE = `${MY_EVENTS_ROUTE}/offer-containter/:eventId/:offerId`;

export const EVENT_SCHEDULE_ROUTE = `${MY_EVENTS_ROUTE}/schedule/:eventId`;

export const WEB_HOOK_ROUTE = `${MY_EVENTS_ROUTE}/web-hook/:eventId`;

export const WEB_HOOK_CONTAINER_ROUTE = `${MY_EVENTS_ROUTE}/web-hook-container/:eventId/:hookId`;

export const EVENT_PERMISSION_ROUTE = `${MY_EVENTS_ROUTE}/permission/:eventId`;

export const EVENT_TAX_REPORT_ROUTE = `${MY_EVENTS_ROUTE}/tax-report/:eventId`;

export const EVENT_COUPONS_ROUTE = `${MY_EVENTS_ROUTE}/coupons/:eventId`;

export const EVENT_FOLLOWER_ROUTE = `${MY_EVENTS_ROUTE}/followers/:eventId`;

export const EVENT_COUPON_CREATE_ROUTE = `${MY_EVENTS_ROUTE}/create-coupon/:eventId`;

export const EVENT_COUPON_EDIT_ROUTE = `${MY_EVENTS_ROUTE}/edit-coupon/:eventId/:couponId`;

export const EVENT_COUPON_CLONE_ROUTE = `${MY_EVENTS_ROUTE}/clone-coupon/:eventId/:couponId`;

export const EXTRA_TC_ROUTE = '/extratc/:eventId';

export const getExtraTCRoute = (eventId: string) => `/extratc/${eventId}`;

export const EXTRA_FIELDS_ROUTE = '/extra-field/:eventId';

export const getExtraFieldsRoute = (eventId: string) => `/extra-field/${eventId}`;

export const PRIORITY_PASS_ROUTE = '/priority-pass/:eventId';

export const getPriorityPassRoute = (eventId: string) => `/priority-pass/${eventId}`;

export const getEditEventFormRoute = (eventId: string) =>
  EDIT_EVENT_FORM_ROUTE.replace(':eventId', eventId);

export const getEditEventPublishRoute = (eventId: string) =>
  EDIT_EVENT_PUBLISH_ROUTE.replace(':eventId', eventId);

export const getAttendeesRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/attendees/${eventId}`;

export const getZreadingRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/zreading/${eventId}`;

export const getScanningRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/scanning/${eventId}`;

export const getEventOfferRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/offer/${eventId}`;

export const getEventScheduleRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/schedule/${eventId}`;

export const getWebHookRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/web-hook/${eventId}`;

export const getWebHookContainerRoute = (eventId: string, hookId: string) =>
  `${MY_EVENTS_ROUTE}/web-hook-container/${eventId}/${hookId}`;

export const getEventOfferContainterRoute = (eventId: string, offerId?: string) =>
  `${MY_EVENTS_ROUTE}/offer-containter/${eventId}/${offerId}`;

export const getTaxReportRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/tax-report/${eventId}`;

export const getCouponsRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/coupons/${eventId}`;

export const getPermissionRoute = (eventId: string) => `${MY_EVENTS_ROUTE}/permission/${eventId}`;

export const getCouponCreateRoute = (eventId: string) =>
  `${MY_EVENTS_ROUTE}/create-coupon/${eventId}`;

export const getCouponEditRoute = (eventId: string, couponId: string) =>
  `${MY_EVENTS_ROUTE}/edit-coupon/${eventId}/${couponId}`;

export const getCouponCloneRoute = (eventId: string, couponId: string) =>
  `${MY_EVENTS_ROUTE}/clone-coupon/${eventId}/${couponId}`;

export const getEventFollowerRoute = (eventId: string) =>
  EVENT_FOLLOWER_ROUTE.replace(':eventId', eventId);
